import { render, staticRenderFns } from "./ReportFarmerSatisfactionSurveys.vue?vue&type=template&id=50516cfb&"
import script from "./ReportFarmerSatisfactionSurveys.vue?vue&type=script&lang=js&"
export * from "./ReportFarmerSatisfactionSurveys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports